import React, { useEffect } from "react";
import { User } from "../../../../@types/user.interface";
import { useRouteMatch, useHistory } from "react-router-dom";
import { Quiz } from "../../../../@types/quiz.interfaces";
import Loading from "../../../../components/loading/loading.component";
import ManageQuestion from "../../../../components/manage-question/manage-question.component";
import { connect } from "react-redux";
import QuizActionAPI, {
    IFetchQuizPayload,
} from "../../../../redux/quiz/quiz.actions";
import { Dispatch } from "redux";
import { fetchApi } from "../../../../redux/fetch/fetch.actions";
import { GlobalState } from "../../../../redux/root-reducer";

interface IProps {
    isFetching?: boolean;
    errors?: string | null;
    user: User | null;
    quiz: Quiz | null;
    fetchQuiz: (id: number) => void;
    clearQuiz: () => void;
}

function ManageQuestionPageContainer({
    isFetching,
    errors,
    user,
    quiz,
    fetchQuiz,
    clearQuiz,
}: IProps) {
    const match = useRouteMatch<{ id: string }>();
    const history = useHistory();
    const id = parseInt(match.params.id);

    useEffect(() => {
        if (isFetching || errors) return;
        if (quiz === null) fetchQuiz(id);
    }, [isFetching, errors, quiz, fetchQuiz, id, user, history]);

    useEffect(() => {
        fetchQuiz(id);
        return () => {
            clearQuiz();
        };
    }, [id, clearQuiz, fetchQuiz]);

    return (
        <div className="container">
            {isFetching ? (
                <Loading className="fixed" />
            ) : (
                <div className="container__content">
                    {quiz?.quiz_id !== undefined &&
                    user?.initial !== undefined ? (
                        <ManageQuestion
                            quizId={quiz?.quiz_id}
                            userEmail={user.initial}
                        />
                    ) : quiz?.quiz_id !== undefined &&
                      user?.email_address !== undefined ? (
                        <ManageQuestion
                            quizId={quiz?.quiz_id}
                            userEmail={user.email_address}
                        />
                    ) : (
                        ""
                    )}
                </div>
            )}
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
    user: { self },
    quiz: { quiz },
}: GlobalState) => ({
    isFetching: isFetching.QUIZ,
    errors: errors.QUIZ,
    user: self.data,
    quiz,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchQuiz: (id: IFetchQuizPayload["data"]["id"]) =>
        dispatch(fetchApi({ name: "QUIZ", data: { id } })),
    clearQuiz: () => dispatch(QuizActionAPI.clearQuiz()),
});

const ManageQuestionPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(ManageQuestionPageContainer);

export default ManageQuestionPage;
